import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {PageModel} from "../../core/_model";

type Props = {
  column: ColumnInstance<PageModel>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
